import React from 'react'

const About = () => {
  return (
	  <section id='about' className='container mx-auto px-2 pt-3 mb-10'>
		  <div className='text-center my-3'>
        <h2 className='text-4xl w-fit mx-auto border-b-2 mb-6 border-amber-500 uppercase'>
          O nás
        </h2>
      </div>
      <div className='md:w-3/4 px-4 md:px-0 mx-auto text-lg'>
        <p>
          Organizace <strong>Centrum sociálních služeb Sokolov, o.p.s.</strong> zahájila svou činnost: 1.7.2008, jako obecně prospěšná společnost s právní subjektivitou.
        </p>
        <p>
          Do 31.12.2002: Byla pečovatelská služba v Sokolově zabezpečována Okresním ústavem sociálních služeb v Sokolově, pod vedením PhDr. Pavla Čáslavy.
        </p>
        <p>
          1.1.2003- 30.6.2008: Od 1.1.2003 převzalo zabezpečování pečovatelské služby Město Sokolov a zřídilo pro tento účel vlastní příspěvkovou organizaci zvanou Pečovatelská služba města Sokolova (PSMS). 
          Tato organizace tak zahájila svou činnost v době, kdy právě došlo k zániku okresních úřadů, což znamenalo završení reformy územní veřejné správy, jejímž hlavním cílem bylo dokončení decentralizace výkonu 
          státní správy, mnohé obce převzaly zabezpečování pečovatelské služby ve svém regionu. PSMS pod vedením Bc. Magdaleny Osičkové poskytovala pečovatelskou službu občanům města Sokolova a některých blízkých obcí, do 30.6. 2008.
        </p>
        <p>
          Od 1.7. 2008 - dosud: Poskytuje pečovatelskou službu občanům v Sokolově organizace Centrum sociálních služeb Sokolov, o.p.s., pod vedením ředitelky Bc. Magdaleny Osičkové. Tato organizace byla založena po rozhodnutí 
          vedení města Sokolova o transformaci jeho příspěvkové organizace Pečovatelská služba města Sokolova.
        </p>
      </div>
    </section>
  )
}

export default About
